export function PaidNonClientPromotionRIA() {
  return (
    <p className="typography-text-extra-small text-muted-foreground">
      Paid non-client promotion. NerdWallet doesn&apos;t invest its money with this provider, but
      they are our referral partner &#45; so we get paid only if you click through and take a
      qualifying action (such as open an account with or provide your contact information to the
      provider). Most importantly, our reviews and ratings are objective and are never impacted by
      our partnerships. Our opinions are our own. Here is a list of{' '}
      <a href="https://www.nerdwallet.com/p/our-partners" className="underline">
        our partners
      </a>{' '}
      and{' '}
      <a href="https://nerdwallet.com/p/advertiser-disclosure" className="underline">
        here&apos;s how we make money
      </a>
      .
    </p>
  );
}
